import { Link } from "react-router";
import * as React from "react";
import styled, { css } from "styled-components";
import { ControlArrowRight } from "./icons/Arrows";

const BoldLinkStyles = css`
  display: inline-flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes[1]};
  color: ${({ theme }) => theme.colors.yellow};
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledBoldLink = styled(Link)`
  ${BoldLinkStyles}
`;

interface IBoldLinkProps {
  children: React.ReactNode;
  to: string;
}

const BoldLink: React.FC<IBoldLinkProps> = ({ children, to }) => (
  <StyledBoldLink to={to}>
    {children}
    <ControlArrowRight />
  </StyledBoldLink>
);

export default BoldLink;
